import PromoAppIndex from './Index';
import { Switch, Route, useRouteMatch } from 'react-router-dom';

const PromoApp = (props) => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route exact path={`${path}`}>
        <PromoAppIndex theme={props.theme} setShowMenu={props.setShowMenu} />
      </Route>
    </Switch>
  );
};

export default PromoApp;
